import { useSingleEntity } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { FC } from 'react'
import * as managers from 'modules/domain/common/managers'
import { SampleDetailed, SampleRequestDocsType, SampleWithRequests } from 'views/pages/Samples/types'
import { PublishLocalForm } from './PublishLocalForm'
import { DocumentFile } from 'modules/domain/types'
import { useAProgress } from 'hooks/useAProgress'
import { Spinner } from 'views/components/CommonTableComponents/CommonTableComponents'
import { ASharedModal, SharedModalTitle } from 'views/components/SharedModal'
import { useTranslation } from 'react-i18next'
import { SampleDataForPublishingBot } from '../../../types'

type Props = {
  sample: SampleDetailed | SampleWithRequests
  onSuccess: () => Promise<void>
  onClose: () => void
}

export const PublishToLocalModal: FC<Props> = ({ onSuccess, sample, onClose }) => {
  const { t } = useTranslation('samples')
  let sample_request_id
  if ('sample_request_id' in sample) {
    sample_request_id = sample.sample_request_id
  } else {
    sample_request_id = sample.sample_requests[0].id
  }
  const [, data] = useSingleEntity<SampleDataForPublishingBot>(endpoints.samplesDataForLocalBot(sample.id.toString()))
  const docsEndpoint = endpoints.sampleRequestDocuments(sample_request_id.toString())
  const [, docs, refetchDocs] = useSingleEntity<DocumentFile[]>(
    `${docsEndpoint}?document_type=${SampleRequestDocsType.local_files}`,
  )
  const [filesProgress, addHandler] = useAProgress(
    async (files: FileList) => {
      const promises: Promise<unknown>[] = []
      for (const file of files) {
        promises.push(
          managers.uploadDocuments(
            endpoints.sampleRequestDocuments(sample_request_id.toString()),
            SampleRequestDocsType.local_files,
            file,
          ),
        )
      }
      await Promise.all(promises)
    },
    {
      eventName: 'addSampleRequestFiles',
      onSuccess: () => refetchDocs(),
    },
  )

  let content

  if (!data || !docs) {
    content = (
      <div
        style={{
          height: 300,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spinner />
      </div>
    )
  } else {
    content = (
      <PublishLocalForm
        data={data}
        onSuccess={onSuccess}
        docs={docs}
        filesProgress={filesProgress}
        addFileHandler={addHandler}
        onClose={onClose}
        sample={sample}
      />
    )
  }

  return (
    <ASharedModal size="medium" onClose={onClose} id="MaxPreview">
      <SharedModalTitle>{t('sendToLocalChat')}</SharedModalTitle>
      {content}
    </ASharedModal>
  )
}
